import React, { Component } from 'react';
import { BrowserRouter as Router, Route} from "react-router-dom";

//https://www.inmotionhosting.com/business-hosting#shared-performance-modal
//https://www.greengeeks.com/web-hosting/


//http://findingmickey.squarespace.com/hidden-mickeys-disneyland/main-street-usa/

import './App.css';

import Helpers from './Helpers.js';
import DisneyData from './DisneyData.js';
import Row from './Row.js';
import NavBar from './NavBar.js';
import Details from './Details.js';
import Adsense from './Adsense.js';

import { DFPSlotsProvider, AdSlot } from 'react-dfp'; //https://github.com/jaanauati/react-dfp

//import Service from './Service.js';

class App extends Component {
	constructor(props) {
		super(props);
		//console.log("construct",this.props.location,this.props.match);

		var nav_stack = [];
		if(this.props.location.pathname==="/") {
			nav_stack = [];
		} else {
			var pieces = this.props.location.pathname.split("/");
			for(var i=1;i<pieces.length;i++) {
				if(!pieces[i].includes(".html")) nav_stack.push(parseInt(pieces[i],10));
			}
		}

		var rows = DisneyData.getData(DisneyData.group,nav_stack);

		this.state = {
			group: DisneyData.group,
			title: "",
			rows: rows,
			nav_stack: nav_stack,
			location:this.props.location,
			saveData: ""
		};
	}

	componentDidMount() {
		DisneyData.init(function() {
			//console.log("initialized",DisneyData.rows.length);
			var group = this.state.group;
			if(this.state.location.pathname==="/save") {
				var data = DisneyData.serialize();
				this.setState({title: "Save Data", saveData: data});
				document.title = "ParkTopper - 100% Disneyland® Checklist";
				document.getElementById("canonical").setAttribute('href',"https://www.parktopper.com/save");
			} else if(this.state.nav_stack.length) {
				var currentID = this.state.nav_stack[this.state.nav_stack.length-1];
				var current;
				if(currentID===0) {
					current = Helpers.findArrayByID(DisneyData.rows,this.state.nav_stack[0]);
					group = current.group;
					this.setState({title: "All "+current.title, group:group});
					document.title = "ParkTopper - All "+current.title;
					var pathall = this.state.nav_stack.join("/");	
					document.getElementById("canonical").setAttribute('href',"https://www.parktopper.com/"+pathall+"/all.html");
				} else {
					current = Helpers.findArrayByID(DisneyData.rows,currentID);

					if(this.state.nav_stack.length===1) {
						group = current.group;
					} else if(this.state.nav_stack.length>1) {
						var parent = Helpers.findArrayByID(DisneyData.rows,this.state.nav_stack[0]);
						group = parent.group;
					}
					DisneyData.changeGroup(group);
					if(current) {
						this.setState({title: current.title, group:group});
						document.title = "ParkTopper - "+current.title;
						var path = this.state.nav_stack.join("/");	
						var filename = current.title.toLowerCase().replace(/'/g,"").replace(/[\W_]+/g,"-")+".html";
						document.getElementById("canonical").setAttribute('href',"https://www.parktopper.com/"+path+"/"+filename);
					}
				}
			} else {
				this.setState({title: "ParkTopper"});
				document.title = "ParkTopper - 100% Disneyland® Checklist";
				document.getElementById("canonical").setAttribute('href',"https://www.parktopper.com/");
			}
			
			var rows = DisneyData.getData(group,this.state.nav_stack);
			this.setState({rows: rows});
		}.bind(this));


		window.setTimeout(function() {
			if(window.googletag && window.googletag.pubads) window.googletag.pubads().refresh();
		});
		
		// window.googletag.cmd.push(function() { 
		// 	window.googletag.display('div-gpt-ad-1536943331729-0'); 
		// });

	}
	
	componentWillUnmount() {
	}

	clicked(row) {
		// var new_stack = Helpers.cloneObject(this.state.nav_stack);
		// new_stack[new_stack.length] = row.id;
		
		// var rows = DisneyData.getData(this.state.group,new_stack);
		// var new_title = Helpers.cloneObject(this.state.title);
		// new_title.push(row.title);
		// this.setState({nav_stack: new_stack, title: new_title, rows: rows});
	}

	checked(row) {
		DisneyData.checkedRow(row);

		var rows = DisneyData.getData(this.state.group,this.state.nav_stack);
		this.setState({rows: rows});
	}

	switchGroup(group) {
		DisneyData.changeGroup(group);
		var rows = DisneyData.getData(group,this.state.nav_stack);
		this.setState({group:group,rows: rows});
	}

	restore() {
		DisneyData.restore(this.state.saveData);
		var rows = DisneyData.getData(this.state.group,this.state.nav_stack);
		this.setState({rows: rows});
	}
	handleRestoreChange(event) {
		this.setState({saveData: event.target.value});
	}
	goBack() {
		// var new_stack = Helpers.cloneObject(this.state.nav_stack);
		// var new_title = Helpers.cloneObject(this.state.title);
		// new_stack.pop();
		// new_title.pop();
		// var rows = DisneyData.getData(this.state.group,new_stack);

		// this.setState({nav_stack: new_stack, title: new_title, rows: rows});
	}

	renderSwitch() {
		if(this.state.nav_stack.length>0) return null;
		var c1 = "";
		var c2 = "";
		if(this.state.group===1) c1 = "active"; else c2 = "active";
		return (
			<div className="switch">
				<button className={c1} onClick={this.switchGroup.bind(this,1)}>Activity</button>
				<button className={c2} onClick={this.switchGroup.bind(this,2)}>Land</button>
			</div>
		);
	}

	//
	renderIntroduction() {
		if(this.state.nav_stack.length>0) return null;
		return (
			<div className="intro">
				ParkTopper.com is a Disneyland<sup>®</sup> checklist that includes every ride, attraction, shop, restaurant, and secret that you can find inside the theme park.  There are 400+ things to discover and check off with this amazing app. Can you get to 100% completion?
			</div>
		);
	}

	//
	renderRows() {
		var rows = this.state.rows;

		if(rows.length===0) {
			return (
				<div className="loading">
					Loading...
				</div>
			)
		}
		return rows.map(function(r,key) {
			if(r.ad===true) return (<Adsense key={key} />)
			else return (<Row key={key} row={r} stack={this.state.nav_stack} clicked={this.clicked.bind(this)} checked={this.checked.bind(this)} />);
		}.bind(this));
	}

	//
	renderTips() {
		if(this.state.nav_stack.length) return null;

		return (
			<div className="tips">
				Are we missing something? Did you find a mistake? Please <a href="mailto:tips@parktopper.com?subject=ParkTopper Feedback">email us</a> and let us know.
			</div>
		)
	}

	//
	renderBottomAd() {
		return (
			<DFPSlotsProvider dfpNetworkId={'1006759'} adUnit={"ParkTopper"} collapseEmptyDivs={true}>
   			<AdSlot 
   				sizes={[[234, 60], [728, 90], [970, 90], [320, 50], [468, 60]]} 
   				adSenseAttributes={{ "adsense_channel_ids": "9427531481"}} />
			</DFPSlotsProvider>
   		);
	}

	//
	render() {
		if(this.state.location.pathname==="/save") {
			return (
				<div>
					<NavBar nav_stack={ this.state.nav_stack } title={ this.state.title } onBack={this.goBack.bind(this)} />
					<div className="paddingCentered">
						<p>You can copy and paste this data somewhere else to save it. To restore that data, copy and paste it back into this box and then press the "restore" button.</p>
						<textarea className="saveForm" value={ this.state.saveData } onChange={this.handleRestoreChange.bind(this)} ></textarea>
						<br />
						<button className="squareBtn" onClick={this.restore.bind(this)}>Restore</button>
					</div>
				</div>
			);
		} else if(this.state.rows.length===1 && this.state.nav_stack[this.state.nav_stack.length-1]===this.state.rows[0].id) {
			var land = Helpers.findArrayByID(DisneyData.rows,this.state.rows[0].land);
			var type = Helpers.findArrayByID(DisneyData.rows,this.state.rows[0].type);
			var bread = land.title+" :: "+type.title;
			return (
				<div>
					<NavBar nav_stack={ this.state.nav_stack } title={ this.state.title } onBack={this.goBack.bind(this)} />
					<Details row={this.state.rows[0]} bread={bread} clicked={this.clicked.bind(this)} checked={this.checked.bind(this)} />
				</div>
			);
		} else {
			return (
				<div>
					<NavBar nav_stack={ this.state.nav_stack } title={ this.state.title } onBack={this.goBack.bind(this)} />
					{ this.renderIntroduction() }
					{ this.renderSwitch() }
					<div className="list">
						{ this.renderRows() }
					</div>
					{ this.renderTips() }
					<div className="bottom" id="bottom">
						ParkTopper is not authorized by, endorsed by, or affiliated with The Walt Disney Company or any of its partners. Read more on our <a href="/legal.html">Terms &amp; Privacy</a> page.
					</div>
				</div>
			);
		}
	}
}

class MyRouter extends Component {
	componentDidMount() {
		//console.log("mount router");

		/*
		This may work to prompt android users to install, but I have no way to test it
		window.addEventListener('beforeinstallprompt', (e) => {
		  // Prevent Chrome 67 and earlier from automatically showing the prompt
		  e.preventDefault();
		  // Stash the event so it can be triggered later.
		  var deferredPrompt = e;

		  deferredPrompt.prompt();
		});
		*/


		if ('serviceWorker' in navigator) {
    		//Service.registerServiceWorker('/ServiceWorker.js');
			
			// Service.registerPushNotifications();
			// Service.displayNotification("Hi There",{
			// 	body: 'Here is a notification body!',
			// 	icon: '/images/0_t.jpg',
			// 	vibrate: [100, 50, 100],
			// 	data: {
			// 		customID: 123
			// 	},
			// 	actions: [
			// 		{action: 'explore', title: 'Explore this new world', icon: 'images/checkmark.png'},
			// 		{action: 'close', title: 'Close notification', icon: 'images/xmark.png'},
			// 	]
			// });		
		}
	}

	render() {
		return( 
			<Router>
				<div className="App">
					<Route exact path="/" component={App} />
					<Route exact path="/:nav1/:nav2/:id/:filename" component={App} />
					<Route exact path="/:nav1/:nav2/:id" component={App} />
					<Route exact path="/:nav1/:nav2" component={App} />
					<Route exact path="/:nav1" component={App} />
				</div>
			</Router>
		)
	}
}

export default MyRouter;



// WEBPACK FOOTER //
// ./src/App.js